import { useMutation } from '@tanstack/react-query';

import { ApiErrorCode, createApiError } from '@/modules/common/api/errors';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { getTeamMemberCapacityConflicts } from '../../api/team.api';
import {
  CheckConflictsParams,
  CheckConflictsResult,
  TeamMemberConflictResolutionData,
} from '../../types/team-member-conflicts';

export const useCheckTeamMemberCapacityConflicts = () => {
  const { displayToastErrorFromApiWithFallback } = useApiError();

  const mutation = useMutation({
    mutationFn: async ({
      teamMemberId,
      startDate,
      endDate,
    }: CheckConflictsParams): Promise<CheckConflictsResult> => {
      const conflictData: TeamMemberConflictResolutionData = await getTeamMemberCapacityConflicts({
        teamMemberId: Number(teamMemberId),
        startDate,
        endDate,
      });

      return {
        items: conflictData.items,
        hasConflicts: conflictData.hasConflicts,
      };
    },
    onError: error => {
      const apiError = createApiError(
        ApiErrorCode.TEAM_MEMBER_CAPACITY_CONFLICTS_LOAD_FAILED,
        error
      );
      displayToastErrorFromApiWithFallback(
        apiError,
        'authenticated.team:api.error.capacityConflictsLoadFailed'
      );
    },
  });

  return {
    checkConflicts: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
